/*function sticky_relocate() {
  	var window_top = $(window).scrollTop();
  	var div_top = $('.filter-menu').offset().top;
  	if (window_top > div_top) {
    	$('#sticky').addClass('stick');
  	} else {
    	$('#sticky').removeClass('stick');
  	}
}

$(function() {
  	$(window).scroll(sticky_relocate);
  	sticky_relocate();
}); */


$(function() {
    $('.lazy').lazy({
        threshold: 0
    });
});

jQuery(document).ready(function($) {
    $(document).on('click', 'a[href^="#"].question', function(e) {
    	var id = $(this).attr('href');

    	var $id = $(id);
    	if ($id.length === 0) {
    	    return;
	    }

	    e.preventDefault();

    	var pos = $id.offset().top;

    	$('body, html').animate({scrollTop: pos}, 1500);
	});
});